//Tabs for expense types and takings types

import * as React from 'react';
import { connect } from 'react-redux';
import { RefreshControl, Platform, Animated, LayoutAnimation, StyleSheet, Image, FlatList, TouchableHighlight } from 'react-native';
import { Container, Header, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem, SwipeRow, Spinner, InputGroup, Input, Item, View, Tab, Tabs, Row } from 'native-base';
import { SwipeListView } from 'react-native-swipe-list-view';
import Modal from '../../components/modal';
import Alert from '../../components/alert';

import diff from 'object-diff';
import Moment from 'moment';
import * as _ from 'lodash';

import CalCalDataApi from '../../api/CalCalDataApi';

import ExpenseTypeForm from '../../forms/expenseTypeForm';
import TakingTypeForm from '../../forms/takingTypeForm';

import PopupMenu from '../../components/popupMenu';
import { Dimensions } from 'react-native-web';

class Budgets extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			searching: false,
			adding: false,
			editingExpense: null,
			editingTaking: null,
			editType: null,
			editItem: null,
			isModalSaving: false,
			tab: 0
		};
	}

	componentDidUpdate(prevProps) {
		if (this.props.route?.params?.tab !== prevProps.route?.params?.tab) {
			this.setState({
				tab: parseInt(this.props.route?.params?.tab)
			});
		}
	}

	ExpenseTypesSubmit(values) {
		//actually submits then fires dispatch to update appropriate store
		if (!values.id) {
			//new
			return CalCalDataApi.dataInsert('expenseCategories', values, this.props.jwt, res => {
				if (res.success && res.id) {
					//this.insertId = res.id.toString() + transType == 'receipt' ? '1' : '2'; //hard coded here for offline compat
					this.props.dispatch({
						type: 'INSERT/expenseCategory', //successful update send UPDATE(d) to store
						entry: res.record
					});
					return false;
				} else if (res.validationErrors) {
					console.log('validationErrors ', res.validationErrors);
					throw new SubmissionError(res.validationErrors);
				}
			});
		}
		//diff values with this.props.busDetails or whatever
		const difference = diff(this.state.editItem, values); //added, deleted, changed, updated (arrays)
		if (Object.keys(difference).length == 0) return false;
		__DEV__ && console.log('SUBITTing', difference);
		return CalCalDataApi.dataUpdate('expenseCategories/' + values.id, difference, this.props.jwt, res => {
			//console.log('handleSubmit ', res);
			if (res.success) {
				this.props.dispatch({
					type: 'UPDATE/expenseCategory', //successful update send UPDATE(d) to store
					difference, //IF no JSON returned, trust local changes
					id: values.id
				});
				return false;
			} else if (res.validationErrors) {
				console.log('validationErrors ', res.validationErrors);
				throw new SubmissionError(res.validationErrors);
			}
		});
	}

	TakingTypesSubmit(values) {
		//actually submits then fires dispatch to update appropriate store
		//diff values with this.props.busDetails or whatever
		__DEV__ && console.log(values, this.state.editItem);
		if (!values.id) {
			//new
			return CalCalDataApi.dataInsert('takingCategories', values, this.props.jwt, res => {
				if (res.success && res.id) {
					//this.insertId = res.id.toString() + transType == 'receipt' ? '1' : '2'; //hard coded here for offline compat
					this.props.dispatch({
						type: 'INSERT/takingCategory', //successful update send UPDATE(d) to store
						entry: res.record
					});
					return false;
				} else if (res.validationErrors) {
					console.log('validationErrors ', res.validationErrors);
					throw new SubmissionError(res.validationErrors);
				}
			});
		}

		const difference = diff(this.state.editItem, values); //added, deleted, changed, updated (arrays)

		if (Object.keys(difference).length == 0) return false;
		__DEV__ && console.log('SUBITTing', difference);

		return CalCalDataApi.dataUpdate('takingCategories/' + values.id, difference, this.props.jwt, res => {
			__DEV__ && console.log('handleSubmit ', res);
			if (res.success) {
				this.props.dispatch({
					type: 'UPDATE/takingCategory', //successful update send UPDATE(d) to store
					difference, //IF no JSON returned, trust local changes
					id: values.id
				});
				return false;
			} else if (res.validationErrors) {
				console.log('validationErrors ', res.validationErrors);
				throw new SubmissionError(res.validationErrors);
			}
		});
	}

	deleteCat(type, id) {
		CalCalDataApi.dataDelete(type.replace('y', 'ies') + '/' + id, this.props.jwt, res => {
			//dispatch({type: 'CUSTOMERS_IS_LOADING', isLoading: false});
			if (res.status == 200 && res.success) {
				this.props.dispatch({
					type: 'DELETE/' + type,
					id
				});
			} else {
				Alert.alert(res.title, `Cannot delete ${type}. \n ${res.error}`);
				if (res.error == 'Expired token')
					dispatch({
						type: 'SET_JWT',
						token: null,
						info: null
					});
			}
		});
	}

	async formBack() {
		if (!this.refs.form) return;
		errors = await this.refs.form.submit();
		this.setState({ editItem: null });
		if (!errors) {
			this.setState({ isModalVisible: false });
		} else {
			return errors;
		}
	}

	async _closeModal() {
		if (!!this.state.editItem && this.refs.form) {
			console.log('saving');
			//still there?
			this.setState({ isModalSaving: true });
			const errors = await this.refs.form.submit();

			if (!errors) {
				this.setState({ isModalSaving: false, isModalVisible: false, editItem: null });
			} else {
				this.setState({ isModalSaving: false });
				return errors;
			}
		} else {
			this.setState({ isModalVisible: false, editItem: null });
		}
	}

	onClosing() {
		__DEV__ && console.log('closing', arguments);
		//can we grab the values here and keep them locally?
		return false;
	}

	deleteRow(type, item) {
		//const cat = type == 'expenseCategory' ? this.props.expenseCategories[row] : this.props.takingCategories[row];
		if (!item) return false; //how?
		return Alert.alert(
			'Delete',
			`Permanently delete ${type.replace('Category', '')} category "${item.categoryName}" ?`,
			[
				{ text: 'Cancel', style: 'cancel' },
				{ text: 'OK', onPress: () => this.deleteCat(type, item.id) }
			],
			{
				cancelable: true
			}
		);
	}

	add() {
		console.log(this.state.tab);
		this.setState({ isModalVisible: true, editType: this.state.tab == 0 ? 'expense' : 'receipt', editItem: {} });
	}

	_renderExpenseType(data, rowMap) {
		const { item } = data;
		const hmrcCat = _.find(this.props.hmrcCats, { id: item.hmrcCat });
		return (
			<ListItem
				style={{ flexDirection: 'column', alignItems: 'stretch', marginHorizontal: 10 }}
				onPress={() => {
					this.setState({ isModalVisible: true, editItem: item, editType: 'expense' });
				}}>
				<Right style={{ position: 'absolute', right: 2, top: 2 }}>
					<PopupMenu
						actions={['Delete']}
						destructiveButtonIndex={0}
						style={{ color: '#999' }}
						onPress={(e, i) => {
							i == 0 && this.deleteRow('expenseCategory', item);
						}}
					/>
				</Right>
				<View style={{ width: '90%', marginLeft: 5, minHeight: 40 }}>
					<Text style={{ fontSize: 18, textAlign: 'left' }}>{item.categoryName}</Text>
					<Text note>{item.description}</Text>
				</View>
				<View style={{ flexDirection: 'row' }}>
					<View style={{ flexDirection: 'column', marginLeft: 10, flex: 3 }}>
						<Row style={{ flex: 1 }}>
							{!!hmrcCat && <Image style={{ height: 16, width: 16 }} source={{ uri: 'https://calc.al/app/resources/project-images/' + hmrcCat.icon }} fadeDuration={0} />}
							<Text style={{ fontSize: 12, marginHorizontal: 10 }}> {!!hmrcCat && hmrcCat.name}</Text>
						</Row>
					</View>
					<View style={{ flexDirection: 'column', marginLeft: 10 }}>
						<Text note>Budget</Text>

						<Row>
							<Text style={{ fontSize: 17 }}>£{item.budget}</Text>
							<Text note style={{ fontSize: 12, alignSelf: 'flex-end' }}>
								{' '}
								/mo
							</Text>
						</Row>
					</View>
				</View>
			</ListItem>
		);
	}

	_renderTakingType(data, rowMap) {
		const { item } = data;
		const hmrcCat = _.find(this.props.hmrcCats, { id: item.hmrcCat });
		return (
			<ListItem
				onPress={() => {
					this.setState({ isModalVisible: true, editItem: item, editType: 'receipt' });
				}}
				style={{ flexDirection: 'column', alignItems: 'stretch', marginHorizontal: 10 }}>
				<Right style={{ position: 'absolute', right: 2, top: 2 }}>
					<PopupMenu
						actions={['Delete']}
						destructiveButtonIndex={0}
						style={{ color: '#999' }}
						onPress={(e, i) => {
							i == 0 && this.deleteRow('takingCategory', item);
						}}
					/>
				</Right>
				<View style={{ width: '90%', marginLeft: 5, minHeight: 40 }}>
					<Text style={{ fontSize: 18, textAlign: 'left' }}>{item.categoryName}</Text>
					<Text note>{item.description}</Text>
				</View>
				<View style={{ flex: 1, flexDirection: 'row' }}>
					<View style={{ flexDirection: 'column', marginLeft: 10, flex: 3 }}>
						<Row style={{ flex: 1 }}>
							<Text style={{ fontSize: 12, marginHorizontal: 10 }}> {item.type.toUpperCase()}</Text>
						</Row>
					</View>
					{!!item.budget && (
						<View style={{ flexDirection: 'column', marginLeft: 10 }}>
							<Text note>Target</Text>

							<Row>
								<Text style={{ fontSize: 17 }}>£{item.budget}</Text>
								<Text note style={{ fontSize: 12, alignSelf: 'flex-end' }}>
									{' '}
									/mo
								</Text>
							</Row>
						</View>
					)}
				</View>
			</ListItem>
		);
	}

	_renderExpenses = Types => <FlatList data={Types} renderItem={this._renderExpenseType.bind(this)} keyExtractor={(item, index) => (index ? index.toString() : null)} />;

	_renderTakings = Types => <FlatList data={Types} renderItem={this._renderTakingType.bind(this)} keyExtractor={(item, index) => (index ? index.toString() : null)} />;

	render() {
		const { editItem, editType, isModalVisible, tab } = this.state;
		const { expenseCategories, hmrcCats, show, busDetails, years, takingCategories, takingTypeLabels } = this.props;

		const { width, height } = Dimensions.get('window');

		let calStart, firstYearStart;

		if (!years) return <Spinner />;

		if (busDetails) {
			calStart = Moment(busDetails.accountingStartDate).format('DD/MM/YY');
			firstYearStart = Moment(years[0].accountingStartDate).format('DD/MM/YY');
		} else {
			calStart = '';
			firstYearStart = '';
		}

		if (!expenseCategories) return <Spinner />;

		//this.ds = new ListView.DataSource({ rowHasChanged: (r1, r2) => r1 !== r2 });

		//list ExpenseTypes. onPress one sets editingItem; this shows form.
		//Form onSubmit is handled here

		return (
			<Container>
				<Modal
					isOpen={!!isModalVisible}
					backButtonClose
					coverScreen
					swipeThreshold={100}
					onClosingState={() => this.onClosing()}
					onClosed={() => this._closeModal()}
					style={styles.modalStyle}
					//backdropOpacity={0.7}
					useNativeDriver>
					<Header style={styles.modalHeader}>
						<Left>
							<Button transparent onPress={() => this.setState({ isModalVisible: false })}>
								<Icon name="close" />
							</Button>
						</Left>
						<Body style={{ flex: 3 }}>
							<Title>
								{editItem?.id ? 'Edit' : 'Add'} {editType}
							</Title>
						</Body>
						<Right>
							{this.state.isModalSaving ? (
								<Spinner />
							) : (
								<Button transparent onPress={() => this._closeModal()}>
									<Icon name="checkmark" />
								</Button>
							)}
						</Right>
					</Header>
					<Content style={styles.modalContainer}>
						{isModalVisible && (
							<View style={{ flex: 1, backgroundColor: 'white' }}>
								{editType == 'expense' ? (
									<ExpenseTypeForm
										initialValues={editItem}
										hmrcCats={hmrcCats}
										calStart={calStart}
										firstYearStart={firstYearStart}
										onSubmit={this.ExpenseTypesSubmit.bind(this)}
										onBack={() => this.formBack()}
										ref="form"
									/>
								) : (
									<TakingTypeForm
										initialValues={editItem}
										takingTypeLabels={takingTypeLabels}
										calStart={calStart}
										firstYearStart={firstYearStart}
										onSubmit={this.TakingTypesSubmit.bind(this)}
										onBack={() => this.formBack()}
										ref="form"
									/>
								)}
							</View>
						)}
					</Content>
				</Modal>
				<Header>
					<Left>
						<Button transparent onPress={() => this.props.navigation.navigate('Settings')}>
							<Icon name="ios-arrow-back" />
						</Button>
					</Left>
					<Body>
						<Title>Budgets</Title>
					</Body>
					<Right>
						<Button onPress={() => this.add()}>
							<Icon name="add" />
						</Button>
					</Right>
				</Header>

				<Tabs page={tab} onChangeTab={({ i }) => this.setState({ tab: i })}>
					<Tab heading="Expense Types" style={{ height: height - 146 }}>
						{this._renderExpenses(expenseCategories)}
					</Tab>
					<Tab heading="Sales Types" style={{ height: height - 146 }}>
						{this._renderTakings(takingCategories)}
					</Tab>
				</Tabs>
			</Container>
		);
	}
}

const mapStateToProps = state => ({
	expenseCategories: state.globalReducer.expenseCategories,
	takingCategories: state.globalReducer.takingCategories,
	takingTypeLabels: state.globalReducer.takingCatTypes,
	hmrcCats: state.globalReducer.taxCategories,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token,
	busDetails: state.globalReducer.busDetails,
	years: state.globalReducer.yrs
});
export default connect(mapStateToProps)(Budgets);

const styles = StyleSheet.create({
	addPerson: {
		//color: '#438eb9',
		alignSelf: 'center'
		//marginLeft: 20
	},
	labelIcon: {
		color: '#2f6483',
		alignSelf: 'center',
		marginRight: 20
	},
	footer: {
		backgroundColor: '#F8F8F8'
	},
	modalStyle: {
		borderRadius: 10,
		width: '90%',
		maxHeight: '95%',
		backgroundColor: 'rgba(0,0,0,0)'
		//flex: 0
	},
	modalContainer: {
		//width: '100%',
		flex: 1,
		//justifyContent: 'center',
		backgroundColor: 'rgba(255,255,255,0)' //'#f8f8fc'
	},
	innerContainer: {
		flex: 1
		//alignItems: 'center',
	},
	modalHeader: {
		height: 45,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	},
	bottomBtns: {
		backgroundColor: '#295670',
		flexDirection: 'row'
	}
});
